export const getGoogleImportUri = (
  recommendationType,
  customerId,
  userId,
  accountId,
  opportunityId
) => {
  const googleImportUri = '/campaign/vnext/googleimport';
  const opportunityType = recommendationType;
  return [
    googleImportUri,
    `?cid=${customerId}`,
    `&uid=${userId}`,
    `&aid=${accountId}`,
    `&opportunityType=${opportunityType}`,
    `&opportunityId=${opportunityId}`,
    '&source=webui',
  ].join('');
};

export const getSetupConvTrackingUri = ({
  recommendationType,
  customerId,
  userId,
  accountId,
  opportunityId,
  statusId,
}) => {
  let uri = '/campaign/vnext/conversiongoals?filterAlias=unverifiedGoals&';
  if (statusId === 0) {
    uri = '/campaign/vnext/uettag?';
  } else if (statusId === 1) {
    uri = '/campaign/vnext/conversiongoals/create?';
  }

  return [
    uri,
    `cid=${customerId}`,
    `&uid=${userId}`,
    `&aid=${accountId}`,
    `&opportunityType=${recommendationType}`,
    `&opportunityId=${opportunityId}`,
    '&source=webui',
  ].join('');
};

export const getUETTagUri = (
  customerId,
  userId,
  accountId,
  opportunityId,
  isMCC
) => [
  '/campaign/vnext/uettag',
  `?cid=${customerId}`,
  `&uid=${userId}`,
  `${isMCC ? '' : `&aid=${accountId}`}`,
  `&opportunityId=${opportunityId}`,
  '&source=webui',
  '&filterAlias=recommendationUetinactive',
].join('');

export const getFacebookImportUri = (
  recommendationType,
  customerId,
  userId,
  accountId,
  opportunityId
) => {
  const googleImportUri = '/campaign/vnext/facebookimport';
  return [
    googleImportUri,
    `?cid=${customerId}`,
    `&uid=${userId}`,
    `&aid=${accountId}`,
    `&opportunityType=${recommendationType}`,
    `&opportunityId=${opportunityId}`,
    '&source=webui',
  ].join('');
};

export const getCreateAdUri = (
  customerId,
  userId,
  accountId,
  campaignId,
  adGroupId
) => {
  const createAdUri = '/campaign/vnext/ads';
  return [
    createAdUri,
    `?cid=${customerId}`,
    `&uid=${userId}`,
    `&aid=${accountId}`,
    `&campaignId=${campaignId}`,
    `&adGroupId=${adGroupId}`,
  ].join('');
};
